import { inject, Injectable } from '@angular/core';
import { isFinanceVertical } from '@rma/generic/domain/helpers';
import { rmaShareReplay } from '@rma/generic/rxjs/operators';
import { CurrentUserContext, CurrentUserService } from '@rma/public/accounts/user';
import { map, Observable } from 'rxjs';
import { ProductUserType, ProductUserTypeGrouping } from './domain/billing.model';
import { BillingUserContext } from './domain/billing-user-context.model';

@Injectable({
  providedIn: 'root',
})
export class BillingUserContextService {
  private readonly userService = inject(CurrentUserService);

  public get userContext$(): Observable<BillingUserContext | null> {
    return this.userService.currentUserContext$.pipe(
      map((profile) => mapBillingUserContext(profile)),
      rmaShareReplay(),
    );
  }
}

function mapBillingUserContext(user: CurrentUserContext | null): BillingUserContext | null {
  if (user === null || user.userType === 'Consumer') return null;

  if (user.userType === 'Agent') {
    return {
      code: user.profileCode,
      productUserType: isFinanceVertical(user.verticalType) ? ProductUserType.MortgageBroker : ProductUserType.RealEstate,
      productUserGroupingType: ProductUserTypeGrouping.Individual,
    };
  } else {
    return {
      code: user.profileCode,
      productUserType: isFinanceVertical(user.verticalType) ? ProductUserType.MortgageBroker : ProductUserType.RealEstate,
      productUserGroupingType: user.isTeam ? ProductUserTypeGrouping.Team : ProductUserTypeGrouping.Office,
    };
  }
}
